module.exports = __webpack_public_path__ + "static/media/so.dee99182.png";